export const TEXT = {
  en: {
    welcome_title: "Welcome to NextScenes",
    welcome_action: "Choose what you want to do.",
    btn_create: "Create a story",
    btn_continue: "Continue writing",
    btn_explore: "Explore stories",
    btn_shelf: "View your shelf",
    btn_close: "Close",
    tagline: "Write with conscience. Read with curiosity.",

    policyLinksTitle: "Policy links for writers and contributors",
    policyLinksBody:
      "Helpful public pages on rights, contributions, publication, benefit-sharing, and simple terms.",
    policyLinksProposalTitle: "Before you submit",
    policyLinksProposalBody:
      "A calm reminder: submit your own original work and review the contributor policy when needed.",
    foundingWritersPilotTitle: "Founding Writers Pilot",
    foundingWritersPilotBody:
      "A doorway for writers carrying original stories and ready to grow them with seriousness, visibility, and reader engagement.",
    foundingWritersPilotLink: "Learn about the pilot",

    storylines_title: "All Storylines",
    storylines_subtitle_all:
      "Browse all books (Storylines). Use search, filters and sorting to explore.",
    storylines_identity_note:
      "A Storyline is a living story space: the book’s public shelf, its Canon path, and its invitation to read or contribute.",
    storylines_subtitle_forum: "Showing Storylines filed under",
    refresh: "Refresh",
    welcome_guide: "Welcome Guide",
    loading_list: "Loading list…",
    search_title_author: "Search title or author...",
    all_forums: "All Forums",
    all_writing_modes: "All Writing Modes",
    sort_recent: "Sort by: Recently updated",
    sort_title: "Sort by: Title (A–Z)",
    sort_canon: "Sort by: Most canon scenes",
    no_storylines_filters: "No storylines match your filters yet.",
    previous: "Previous",
    next: "Next",
    page: "Page",
    of: "of",

    more: "More",
    lang: "Language",
    home: "Home",
    storyHub: "Story Hub",
    writerStudio: "Writer Studio",
    readerView: "Reader View",
    publicSite: "Public Site",
    login: "Login",
    createAccount: "Create Account",
    betaFeedback: "Beta Feedback",
    logout: "Logout",
    forums: "Forums",
    storylines: "Storylines",
    myShelf: "My Shelf",
    profile: "Profile",
    mystery250: "Mystery250",
    notifications: "Notifications",
    admin: "Admin",
    adminWriterReviews: "Writer Reviews",
    english: "🇬🇧 English",
    french: "🇫🇷 Français",

    welcome_intro:
      "NextScenes has different working spaces. Choose your path based on what you want to do.",
    choose_path: "Choose your path",
    small_note: "A small note",
    welcome_storyhub_desc:
      "Start a new storyline and organize your story world.",
    welcome_writer_desc:
      "Continue writing, add canon scenes, or submit proposals to an existing story.",
    welcome_reader_desc:
      "Explore storylines and read validated scenes.",
    welcome_note_body:
      "If you came to begin a new story, use Story Hub. If you came to continue writing or contribute to a story, use Writer Studio.",
    dont_show_greeting: "I don’t want to see this greeting again",
    open_storyhub: "Open Story Hub",
    continue_writer: "Continue in Writer Studio",
    open_writer: "Open Writer Studio",
    open_reader: "Open Reader View",
    signed_in_as: "Signed in as",

    forum_labels: {
      "Action Forum": "Action",
      "Adventure Forum": "Adventure",
      "Children Forum": "Children",
      "Comedy Forum": "Comedy",
      "Crime Forum": "Crime",
      "Fantasy Forum": "Fantasy",
      "Historical Forum": "Historical",
      "Inspirational Stories Forum": "Inspirational Stories",
      "Mystery Forum": "Mystery",
      "Poetry Forum": "Poetry",
      "Romance Forum": "Romance",
      "Suspense / Thriller Forum": "Suspense / Thriller",
      "Science Fiction Forum": "Science Fiction",
      "Faith & Inspiration Forum": "Faith & Inspiration",
      "Humour Forum": "Humour",
      "Non-Fiction Stories Forum": "Non-Fiction Stories",
      "Young Adult Forum": "Young Adult",
      "Young Illustrators Gallery": "Young Illustrators Gallery",
      "Comics & Illustrated Stories Forum": "Comics & Illustrated Stories",
      "NextScenes Originals": "NextScenes Originals",
      "Unclassified Forum": "Unclassified",
    },

    visual_story_lane_notices: {
      "Young Illustrators Gallery": {
        title: "Young Illustrators Gallery: protected space",
        body:
          "Young Illustrators Gallery is a protected space for artwork created by children and young people. Children’s artwork must be submitted only by a parent, guardian, teacher, or approved adult. Do not include a child’s full name, face, school name, address, phone number, or any private identifying detail.",
        guardrail: "Children create. Adults submit. NextScenes moderates.",
      },
      "Comics & Illustrated Stories Forum": {
        title: "Comics & Illustrated Stories",
        body:
          "For comic creators, illustrators, and visual storytellers. This space is for illustrated storytelling, comic series, panels, captions, and visual narrative work.",
        guardrail: "",
      },
      "NextScenes Originals": {
        title: "NextScenes Originals",
        body:
          "For platform-curated or in-house story projects, including featured comic series, official experiments, and selected creative works.",
        guardrail: "",
      },
    },

    sceneIllustrationOptional: "Optional scene illustration",
    sceneIllustrationPendingNotice:
      "Illustrations are saved for review first. They do not appear publicly until approved by the story owner or an admin.",
    sceneIllustrationConsentLine:
      "By adding an illustration, you confirm you have permission to use it.",
    sceneIllustrationPolicyLink: "Illustration Upload Policy",
    coverUploadLabel: "Upload book cover",
    coverUploadHint: "JPG, PNG, or WEBP. Maximum 5 MB.",
    coverUploadButton: "Upload cover",
    coverUploading: "Uploading…",
    coverUploadSuccess: "Cover uploaded. The URL has been added to the cover field.",
    illustrationApprovalGuardrail:
      "Approve only suitable, lawful, scene-related illustrations.",
    sceneIllustrationUrl: "Illustration image URL",
    sceneIllustrationCaption: "Caption",
    sceneIllustrationCredit: "Artist / credit",
    sceneIllustrationAltText: "Alt text for accessibility",
    sceneIllustrationLabel: "Scene illustration",
    sceneIllustrationPending: "Pending review",
    sceneIllustrationApproved: "Approved",
    sceneIllustrationRejected: "Rejected",
    sceneIllustrationReviewReason: "Reason",
    sceneIllustrationReviewNote: "Note",
    sceneIllustrationReasonDoesNotMatch: "Does not match the scene",
    sceneIllustrationReasonImageQuality: "Image quality is not suitable",
    sceneIllustrationReasonConsentCopyright: "Consent or copyright concern",
    sceneIllustrationReasonSafetyPolicy: "Safety or policy concern",
    sceneIllustrationReasonOther: "Other",
    sceneIllustrationHelpSummary: "Rules and review",
    sceneIllustrationFileHelpSummary: "File help",
    sceneIllustrationReviewPanel: "Illustration review",
    sceneIllustrationReviewAction: "Review action",
    sceneIllustrationApproveButton: "Approve illustration",
    sceneIllustrationRejectButton: "Reject illustration",
    sceneIllustrationClearButton: "Clear illustration",
    sceneIllustrationChooseReason: "Choose a reason",
    sceneIllustrationRejectNotePlaceholder: "Optional note for the contributor…",
    sceneIllustrationRejectionReasonRequired: "Please choose a rejection reason.",
    sceneIllustrationReviewSaved: "Illustration review saved.",
    sceneIllustrationReviewFailed: "Illustration review failed. Please try again.",
    sceneIllustrationConfirmLabel: "I confirm this is the correct illustration for this scene.",
    sceneIllustrationConfirmRequired: "Please confirm this illustration before continuing.",

    writing_mode_labels: {
      Solo: "Solo",
      Collaborative: "Collaborative",
      "Group (Open)": "Group (Open)",
      "Group (Closed)": "Group (Closed)",
    },

    card_by: "By",
    card_storyline_fallback: "Storyline",
    card_story: "Story",
    card_unknown_author: "Unknown author",
    card_untitled_story: "Untitled Story",
    card_a_nextscenes_story: "A NextScenes Story",
    card_created: "Created",
    card_last_updated: "Last updated",
    card_created_unknown: "Created: unknown",
    card_tooltip_created: "Created",
    card_tooltip_updated: "Updated",
    card_canon: "canon",
    card_canon_scene_singular: "canon scene",
    card_canon_scene_plural: "canon scenes",

    breadcrumb_home: "HOME",
    breadcrumb_forums: "FORUMS",
    breadcrumb_storylines: "STORYLINES",

    btn_writer_room: "Writer Room",
    btn_reader_view: "Reader View",
    btn_continue_updated: "Continue · Updated",
    btn_continue_only: "Continue",
    btn_save_to_shelf: "Save to Shelf",
    btn_view_on_amazon: "View on Amazon",
    status_published_amazon: "Published on Amazon",
    status_preview_on_nextscenes: "Preview on NextScenes",
    status_published_book: "Published Book",
    status_published_preview: "Published preview",
    status_completed_book: "Completed Book",
    status_completed_preview: "Completed preview",
    btn_view_published_book: "View Published Book",
    btn_view_book: "View Book",
    status_in_development: "In Development",
    status_not_published: "Not Yet Published",
    btn_saved: "Saved ✓",
    btn_saving: "Saving…",
    btn_opening: "Opening…",
    btn_login_to_write: "Login to Write",

    title_show_welcome_again: "Show the welcome guide again",
    title_open_reader_view: "Open Reader View",
    title_login_required_writer_studio:
      "Login required to enter Writer Studio.",
    title_enter_writer_studio: "Enter Writer Studio.",
    title_save_storyline_to_shelf: "Save this storyline to your shelf.",
    title_login_required_shelf: "Login required to save to shelf.",
    title_view_profile: "View profile",

    feedback_tracking_load_failed: "Tracking could not be loaded.",
    feedback_login_required_shelf: "Login required to save to Shelf.",
    feedback_removed_from_shelf: "Removed from Shelf.",
    feedback_saved_to_shelf: "Saved to Shelf ✓",
    feedback_shelf_action_failed:
      "Shelf action failed. Please try again.",
    feedback_login_required_writer_room:
      "Login required to enter Writer Room.",
    feedback_opening_writer_room: "Opening Writer Room…",
    feedback_opening_reader_view: "Opening Reader View…",
    alert_login_first: "Please log in first.",

    aboutAuthorTitle: "About the Author",
    descriptionPlaceholderShort:
      "A short description of this storyline...",
    alertWriterFallback:
      "Open Writer Studio from the top menu, then select this storyline.",
    alertReaderFallback:
      "Open Reader View from the top menu, then select this storyline.",

    writerStudioTitle: "Writer Studio",
    writerStudioLocked:
      "This area is locked. You must log in to access the Writer Studio.",
    goToLogin: "Go to Login",
    backToStorylines: "Back to Storylines",

    close: "Close",
    cancel: "Cancel",
    back: "Back",
    welcome: "Welcome",
    clear: "Clear",
    unknown: "Unknown",
    general: "General",

    draftRestored: "Draft restored",
    draftSaved: "Draft saved",
    autosaved: "Autosaved",
    draftCleared: "Draft cleared",

    commentWriterBlocked:
      "The writer cannot comment in Reader Feedback.",
    commentUsernameRequired: "You must be signed in to comment.",
    commentUsernameRequiredReply:
      "You must be signed in to comment.",
    commentEmpty: "Comment cannot be empty.",
    commentPosted: "Comment posted.",
    commentFailed: "Failed to post comment.",

    replyWriterBlocked: "The writer cannot reply here.",
    replyUsernameRequired: "You must be signed in to reply.",
    replyEmpty: "Reply cannot be empty.",
    replyPosted: "Reply posted.",
    replyFailed: "Failed to post reply.",

    readerViewTitle: "Reader View",
    readerViewSubtitle:
      "Guests can read. Explore storylines, learn about each book, and view the last five validated scenes.",
    readerViewGuidanceGuest:
      "Tip: Click any storyline to view its details. Use Last Five Validated Scenes to sample the writing. Login to save storylines to your Shelf and participate.",
    readerViewGuidanceUser:
      "Tip: Click a storyline to open it. Use Last Five Validated Scenes to read quickly. Save to your Shelf when you want to keep it.",
    trackingLastOpenedLabel: "Reading continuity",
    trackingLastOpened: "Last opened {time}",
    trackingLastOpenedHelper:
      "NextScenes remembers your last visit to this storyline.",
    trackingNotOpenedYet: "Not opened yet",
    trackingLoading: "Updating continuity…",
    sceneRatingPrompt: "Your rating",
    sceneRatingSaved: "Saved.",
    sceneRatingGuestSaved: "Saved as guest.",
    sceneRatingSaving: "Saving…",
    sceneRatingError: "Not saved.",
    sceneRatingAria: "Rate this scene {rating} out of 5",
    sceneRatingCurrent: "Your rating: {rating}/5",
    sceneRatingSummaryLabel: "Reader response",
    sceneRatingSummaryEmpty: "Be among the first to rate this scene.",
    sceneRatingSummarySingular: "{count} reader rating",
    sceneRatingSummaryPlural: "{count} reader ratings",
    sceneRatingSummaryAria: "Average rating {average} out of 5, based on {count} ratings",
    sceneReactionPrompt: "What did you feel?",
    sceneReactionSaved: "Reaction saved.",
    sceneReactionGuestSaved: "Reaction saved as guest.",
    sceneReactionSaving: "Saving reaction…",
    sceneReactionError: "Reaction not saved.",
    sceneReactionAria: "Choose reaction: {reaction}",
    sceneReactionCurrent: "{count} reaction selected.",
    sceneReactionLabels: {
      want_more: "I want more",
      exciting: "Exciting",
      emotional: "Emotional",
      like_character: "I like this character",
      confusing: "Confusing",
      too_long: "Too long",
      afraid_for_character: "I fear for this character",
      curious_ending: "Curious ending",
    },
    readerSignals: "Reader signals",
    readerSignalsWaiting: "Waiting",
    readerSignalsSingular: "{count} signal",
    readerSignalsPlural: "{count} signals",
    readerCopyProtectionNotice: "Protected reading: copying is disabled.",

    searchPlaceholder: "Search title, author, forum, mode…",
    filterByMode: "Filter by writing mode",
    allModes: "All modes",
    collaborative: "Collaborative",
    solo: "Solo",
    groupOpen: "Group Open",
    groupClosed: "Group Closed",
    clearSearch: "Clear search",
    showing: "Showing",
    matched: "matched",
    noStorylinesFound: "No storylines match your search.",

    writingModeLabel: "Writing Mode",
    by: "By",
    openStorylineHint:
      "Open to see storyline details and validated scenes.",
    lastFiveScenes: "Last Five Validated Scenes",
    selected: "Selected",

    storylineInformation: "Storyline Information",
    dateTimeCreated: "Date and Time Created",
    lastUpdated: "Last Updated",
    validatedScenes: "Validated Scenes",
   
    description: "Description",
    aboutTheAuthor: "About the Author",
    synopsis: "Synopsis",
    noDescriptionYet: "No description yet.",
    noAuthorBioYet: "Author bio not provided yet.",
    noSynopsisYet: "Synopsis not provided yet.",
    loginToParticipate: "Login to Participate",
    readersShapeFuture: "Readers shape the future here.",
    readerGuestInvite:
      "Login to use Shelf, propose the next scene, vote on reader proposals, and join discussions.",
    loginToUseShelf: "Login to use Shelf",
    shelf: "Shelf",
    checking: "Checking…",
    removeFromShelf: "Remove from Shelf",
    saveToShelf: "Save to Shelf",
    checkingShelf: "Checking Shelf…",
    onMyShelf: "On My Shelf",
    notOnShelf: "Not on Shelf",
    soloWriting: "Solo Writing",
    collaborativeWriting: "Collaborative Writing",
    groupWritingOpen: "Group Writing (Open)",
    groupWritingClosed: "Group Writing (Closed)",

    unclassifiedForum: "Unclassified Forum",
    filterAll: "All Stories",
    shortStoryLabel: "Short Story",
    storyType: "Story Type",

    writerAccessTitle: "Writer Access",
    writerAccessLoginRequired:
      "You must be logged in to request Writer access.",
    requestSubmitted:
      "Request submitted. An admin will review it.",
    requestFailed: "Failed to submit request.",

    writerStudioSubtitle:
      "Choose a storyline, craft canon scenes, review proposed scenes, and follow reader feedback in one place.",
    noStorylinesMessage:
      "No storylines found yet. Create one in Story Hub, then return to Writer Studio.",
    searchFilters: "Search & Filters",
    clearFiltersTitle: "Clear search and filters",
    selectStorylineInstruction:
      "Select a storyline to enter its Writer Studio.",

    writerStudioCurrentState: "CURRENT STATE",
    writerStudioCanonMode: "Canon Mode",
    writerStudioCanonModeDesc:
      "Writer is shaping the official story. Proposals are closed.",
    writerStudioProposalRoundOpen: "Proposal Round Open",
    writerStudioProposalRoundOpenDesc:
      "Readers are shaping the next scene.",
    writerStudioActivitySummary: "ACTIVITY SUMMARY",
    writerStudioCanon: "Canon",
    writerStudioProposals: "Proposals",
    writerStudioComments: "Comments",
    writerStudioReplies: "Replies",
    writerStudioVotes: "Votes",

    writerStudioShareStoryline: "Share Storyline",
    writerStudioReadFullBookDraft: "Read Full Book Draft",
    writerStudioFullBookDraft: "Full Book Draft",
    writerStudioFullBookDraftDesc:
      "Writer-only view of the entire canon so far.",
    writerStudioDownloadDraftTxt: "Download Draft (.txt)",

    writerStudioDecisionLog: "Decision Log",
    writerStudioDecisionLogDesc:
      "A short record of approvals, rejections, and round resets.",
    writerStudioNoDecisionsYet: "No decisions logged yet.",

    writerStudioReaderView: "Reader View",
    writerStudioRecentCanonSnippets:
      "RECENT CANON SCENES (SNIPPETS)",
    writerStudioViewValidatedScenes: "View Validated Scenes",
    writerStudioValidatedCanonScenes:
      "Validated Canon Scenes",
    writerStudioProposalsOpenLabel: "Proposals Open",
    writerStudioValidatedCanonScenesDesc:
      "Shows only the last five validated scenes (same rule as Reader View).",

    writerStudioCallForProposedScenes:
      "Call for Proposed Scenes",
    writerStudioOpenProposalRound: "Open Proposal Round",
    writerStudioOpenProposalRoundDesc:
      "Optional: write a short Next Scene Intent to guide readers.",
    writerStudioNextSceneIntentOptional:
      "Next Scene Intent (optional)",
    writerStudioOpenProposals: "Open Proposals",

    writerStudioWritingWindows: "WRITING WINDOWS",
    writerStudioWhereWorkHappens: "Where the work happens.",
    writerStudioMode: "Mode",
    writerStudioState: "State",
    writerStudioWriteCanonOrOpenRound:
      "Write the next canon scene here or open the next scene round if this mode allows it.",
    writerStudioReadersCanSubmitProposals:
      "Readers can submit proposals. When you are ready, review and approve the best one to mint the next canon scene.",
    writerStudioCanonLockedNotWriter:
      "You are not the storyline writer, so canon writing is locked.",
    writerStudioAddCanonSceneWindow:
      "Add Canon Scene (Window)",
    writerStudioAddCanonScene: "Add Canon Scene",
    writerStudioSubmitProposalWindow:
      "Submit Proposal (Window)",
    writerStudioKeepReadable:
      "Recommended length: 200 to 500 words. A short exception up to 550 words may be allowed for readability.",
    writerStudioStatus: "Status",
    writerStudioWaiting: "Waiting",
    writerStudioWordCount: "Word count",
    writerStudioShortParagraphTip:
      "Tip: write in short paragraphs. If the text looks clustered, press Enter to start a new paragraph before saving.",
    writerStudioSceneTitle: "Scene title",
    writerStudioSceneText: "Scene text",
    writerStudioGenerateTestText: "Generate Test Text",
    writerStudioSaveCanonScene: "Save Canon Scene",

    writerStudioSubmitProposal: "Submit Proposal",
    writerStudioKeepParagraphsHelp:
      "Recommended length: 200 to 500 words. A short exception up to 550 words may be allowed for readability. Paragraphs help.",
    writerStudioProposalTitle: "Proposal title.",
    writerStudioProposedSceneText: "Proposed scene text.",
    writerStudioSaveAsDraft: "Save as Draft",
    writerStudioClearSavedDraft: "Clear saved draft",

    writerStudioStoryInfoButton: "Story Info",
    writerStudioStoryInfo: "Story Info",
    writerStudioStoryInfoDesc:
      "Governance and history of this storyline. Search events, contributors, and scene titles.",
    writerStudioSearchHistory:
      "Search history, contributor, or date",
    writerStudioAllHistory: "All history",
    writerStudioShowingMatchingHistoryItems:
      "Showing of matching history items.",
    writerStudioStoryConstitution: "Story Constitution",
    writerStudioWritingMode: "Writing Mode",
    writerStudioCollaborativeWriting:
      "Collaborative Writing",
    writerStudioStoryOwner: "Story Owner",
    writerStudioCanonAuthority: "Canon Authority",
    writerStudioContributionType: "Contribution Type",
    writerStudioProposalsOpenOnlyWhenAuthorOpens:
      "Proposals open only when the author opens a proposal round.",
    writerStudioCurrentMode: "Current Mode",
    writerStudioParticipation: "Participation",
    writerStudioRegisteredWritersMaySubmit:
      "Registered writers may submit proposals during proposal rounds.",
    writerStudioCanonProtection: "Canon Protection",
    writerStudioApprovedScenesPermanent:
      "Approved scenes become permanent canon.",
    writerStudioStoryOwnerValue: "Story Owner",

    writerStudioStoryHistory: "Story History",
    writerStudioScrollableProvenance:
      "Scrollable provenance timeline.",
    writerStudioCanonSceneAdded: "Canon Scene added.",
    writerStudioStoryCreated: "Story Created.",

    writerStudioProposedScenesNextRound:
      "PROPOSED SCENES (NEXT SCENE ROUND)",
    writerStudioProposalLabel: "Proposal",
    writerStudioGood: "Good",
    writerStudioIncompatible: "Incompatible",
    writerStudioNeutral: "Neutral",
    writerStudioViewFullProposal: "View Full Proposal",
    writerStudioApproveAsNextScene:
      "Approve as Next Scene",
    writerStudioRejectProposal: "Reject Proposal",
    writerStudioRejectAllProposals:
      "Reject All Proposals",
    writerStudioAllProposalsRejected:
      "All proposals rejected. Proposals are closed. Canon Mode is unlocked.",
    writerStudioNoProposalsYet:
      "Proposals are open, but no one has submitted yet.",

    writerStudioReaderFeedback: "READER FEEDBACK",
    writerStudioProposalRound: "Proposal Round",
    writerStudioReaderFeedbackDesc:
      "Readers may post feedback and replies. The writer cannot comment here.",
    writerStudioPostAComment: "Post a comment.",
    writerStudioShareYourFeedback: "Share your feedback.",
    writerStudioRepliesStayUnder:
      "Replies stay under the comment they answer.",
    writerStudioPostComment: "Post comment",
    writerStudioWritersCannotCommentPlaceholder:
      "Writers cannot comment.",

    writerStudioProposalsClosedCallNextRound:
      "Proposals are closed. The writer may call for proposed scenes to open the next round.",

    writerStudioClosedGroupCommentReplyOnly:
      "This is a closed group. Only members can interact.",
    writerStudioGroupCommentReplyOnly:
      "Only group participants can interact here.",
    writerStudioGroupOwnerProposalsOpen:
      "Group owner controls proposal rounds.",
    writerStudioGroupAcceptedMembersMayContribute:
      "Approved members may contribute.",
    writerStudioClosedGroupOwnerProposalsOpen:
      "Group owner controls proposals in closed mode.",
    writerStudioOnlyInvitedGroupMembersMayContribute:
      "Only invited members may contribute.",
    writerStudioCanonLockedUntilDecision:
      "Canon is locked until a decision is made.",

    currentState: "CURRENT STATE",
    canonMode: "Canon Mode",
    canonModeDesc:
      "Writer is shaping the official story. Proposals are closed.",
    proposalRoundOpen: "Proposal Round Open",
    proposalRoundOpenDesc:
      "Readers are shaping the next scene. Canon is locked until the writer decides.",

    activitySummary: "ACTIVITY SUMMARY",
    canon: "Canon",
    proposals: "Proposals",
    comments: "Comments",
    replies: "Replies",
    votes: "Votes",

    shareStoryline: "Share Storyline",
    readFullDraft: "Read Full Book Draft",
    fullBookDraft: "Full Book Draft",
    writerOnlyView:
      "Writer-only view of the entire canon so far.",
    downloadDraft: "Download Draft (.txt)",

    decisionLog: "Decision Log",
    decisionLogDesc:
      "A short record of approvals, rejections, and round resets.",
    noDecisions: "No decisions logged yet.",

    recentCanonScenes:
      "RECENT CANON SCENES (SNIPPETS)",
    viewValidatedScenes: "View Validated Scenes",
    validatedCanonScenes: "Validated Canon Scenes",
    proposalsOpen: "Proposals Open",
    validatedScenesNote:
      "Shows only the last five validated scenes.",

    callForProposals: "Call for Proposed Scenes",
    openProposalRound: "Open Proposal Round",
    nextSceneIntentLabel: "Next Scene Intent (optional)",
    nextSceneIntentPlaceholder:
      "Guide readers on what should happen next...",
    openProposals: "Open Proposals",

    writingWindows: "WRITING WINDOWS",
    whereWorkHappens: "Where the work happens.",
    mode: "Mode",
    state: "State",
    proposalRoundOpenShort: "Proposal Round Open",
    writeCanonInstruction:
      "Write the next canon scene here or open the next scene round if this mode allows it.",
    proposalInstruction:
      "Readers can submit proposals. When you are ready, review and approve the best one.",
    canonLocked:
      "You are not the storyline writer, so canon writing is locked.",
    addCanonScene: "Add Canon Scene (Window)",
    submitProposalWindow: "Submit Proposal (Window)",

    sceneTitle: "Scene title",
    sceneText: "Scene text",
    generateTestText: "Generate Test Text",
    saveCanonScene: "Save Canon Scene",
    wordCount: "Word count",
    status: "Status",
    waiting: "Waiting",
    writingTip:
      "Tip: write in short paragraphs for better readability.",

    proposalTitle: "Proposal title",
    proposalText: "Proposed scene text",
    saveDraft: "Save as Draft",
    clearDraft: "Clear saved draft",
    submitProposalBtn: "Submit Proposal",

    storyInfo: "Story Info",
    storyInfoDesc:
      "Governance and history of this storyline.",
    searchHistory:
      "Search history, contributor, or date",
    allHistory: "All history",
    showingResults: "Showing matching history items.",
    storyConstitution: "Story Constitution",
    writingMode: "Writing Mode",
    storyOwner: "Story Owner",
    canonAuthority: "Canon Authority",
    contributionType: "Contribution Type",
    proposalRule:
      "Proposals open only when the author opens a proposal round.",
    currentMode: "Current Mode",
    participation: "Participation",
    participationRule:
      "Registered writers may submit proposals during proposal rounds.",
    canonProtection: "Canon Protection",
    canonProtectionRule:
      "Approved scenes become permanent canon.",

    storyHistory: "Story History",
    timelineDesc: "Scrollable provenance timeline.",
    canonSceneAdded: "Canon Scene added.",
    storyCreated: "Story Created.",

    proposedScenes:
      "PROPOSED SCENES (NEXT SCENE ROUND)",
    proposal: "Proposal",
    good: "Good",
    incompatible: "Incompatible",
    neutral: "Neutral",
    viewFullProposal: "View Full Proposal",
    approveNextScene: "Approve as Next Scene",
    rejectProposal: "Reject Proposal",
    rejectAll: "Reject All Proposals",
    allRejected:
      "All proposals rejected. Canon Mode is unlocked.",
    noProposalsYet:
      "Proposals are open, but no one has submitted yet.",

    readerFeedback: "READER FEEDBACK",
    stateLabel: "State",
    proposalRound: "Proposal Round",
    feedbackRule:
      "Readers may post feedback and replies. The writer cannot comment here.",
    postComment: "Post a comment",
    shareFeedback: "Share your feedback",
    replyStructure:
      "Replies stay under the comment they answer.",
    postCommentBtn: "Post comment",

    submitProposalModalTitle: "Submit Proposal",
    submitProposalModalDesc:
      "Recommended length: {min} to {recommendedMax} words. A short exception up to {max} words is allowed when readability needs it. Paragraphs help.",

    addCanonModalTitle: "Add Canon Scene",
    addCanonModalDesc:
      "Write a clear and well-structured scene.",
    canonLengthGuidance:
      "Recommended length: {min} to {recommendedMax} words. A short exception up to {max} words is allowed when readability needs it.",

    historyLoadMore: "Load more",
    historyShowing: "Showing",
    historyOf: "of",
    historyEntries: "entries",

    submitProposalModalDescStart: "Recommended length:",
    and: "and",
    words: "words.",
    paragraphsHelp: "Paragraphs help.",

    addParagraphBreaks: "Add paragraph breaks",

    noValidatedScenesYet: "No validated scenes yet.",
    waitingForProposals: "Waiting for proposals",

    

    
     

    proposalsDisabledSolo: "Solo Writing Mode: proposals are disabled.",
    onlyWriterCanOpenProposals: "Only the storyline writer can call for proposed scenes.",
    proposalsAlreadyOpen: "Proposals are already open.",
    openNextSceneRound: "Open the next scene round for readers.",
    

    postReply: "Post Reply",

    reply: "Reply",
    closeReply: "Close Reply",

    saving: "Saving…",

    submitting: "Submitting…",

   
    openProposalRoundDesc: "Optional: write a short Next Scene Intent to guide readers.",
   

    decisionNoteRequired: "Decision Note Required",
    decisionNoteDesc: "Write a short reason for approving this proposal as canon.",
    approving: "Approving",
    untitledProposal: "Untitled Proposal",
    decisionNoteLabel: "Decision note",

    approveAsCanon: "Approve as Canon",

    writerOnlyAccess: "Only the writer can view this.",
    noCanonYet: "No canon yet.",

    loadMore: "Load More",
    showAllVisible: "Show All Visible",
    collapse: "Collapse",

    historyPerformanceNote:
    "For performance, this modal renders up to {max} filtered items at a time. Search or filter to narrow very large histories.",

    fullProposal: "Full Proposal",

    nextSceneIntentFromWriter: "Next Scene Intent (from writer)",

    author: "Author",
    forum: "Forum",

    tooLong: "Too long",
tooShort: "Too short",
addParagraphs: "Add paragraphs",
needsTightening: "Needs tightening",
notReady: "Not ready",
allowedException: "Allowed exception",

ownersManageProposals: "Owners manage proposals; they don’t submit them.",
closedGroupOnlyInvited: "This is a closed group story. Only invited members can contribute.",
groupOnlyInvited: "This is a group story. Only invited members can submit and view proposals.",
collabRequiresWriterAccount: "Collaborative proposals require a Writer account.",
proposalsClosedWaitWriter: "Proposals are closed. Wait until the writer opens the round.",

preparingWorkspace: "Preparing your workspace…",
restoringSession: "Restoring session and loading storylines.",
pleaseWait: "Please wait…",
   

    
    storiesLoadFailed: "Could not reach the server. No storylines loaded yet.",
    provideSceneTitle: "Please provide a title for the scene.",
    writeSceneText: "Please write the scene text.",
    onlyWriterCanAddCanonScenes: "Only the storyline writer can add canon scenes.",
    soloAuthorOnlyCanon: "Solo writing is author-only. You cannot add canon scenes to a Solo story you did not create.",
    sceneAlreadySaved: "This scene is already saved. Make a change before saving again.",
    canonSceneSavedValidated: "Canon scene saved and validated.",
    onlyWriterCanCallProposals: "Only the storyline writer can call for proposed scenes.",
    proposalsDisabledForStoryline: "Solo Writing Mode: proposals are disabled for this storyline.",
    failedToOpenProposals: "Failed to open proposals. Please try again.",
    provideClearerTitle: "Please provide a clearer title (at least 6 characters).",
    writeProposedSceneText: "Please write the proposed scene text.",
    mainWriterCannotSubmitProposals: "As the main writer, you cannot submit proposals. Readers propose, you judge.",
    writerHasNotOpenedProposalRound: "The writer has not opened this round for proposals yet.",
    proposedSceneSubmitted: "Proposed scene submitted for this storyline.",
    failedToSubmitProposal: "Failed to submit proposal. Please try again.",
    onlyWriterCanApproveProposals: "Only the storyline writer can approve proposed scenes.",
    failedToApproveProposal: "Failed to approve proposal. Please try again.",
    onlyWriterCanRejectProposals: "Only the storyline writer can reject proposed scenes.",
    proposedSceneRejectedRemoved: "Proposed scene rejected and removed.",
    failedToRejectProposal: "Failed to reject proposal. Please try again.",
    onlyWriterCanRejectAllProposals: "Only the storyline writer can reject all proposed scenes.",
    failedToRejectAllProposals: "Failed to reject all proposals. Please try again.",
    votingOnlyWhenProposalsOpen: "Voting is only available while proposals are open.",
    writerCannotVoteOnProposals: "The writer cannot vote on proposals.",
    setUsernameBeforeVoting: "Please set a username before voting.",
    cannotVoteOwnProposal: "You cannot vote on your own proposed scene.",
    alreadyVotedOnProposal: "You have already voted on this proposal.",
    voteRecorded: "Your vote has been recorded.",
    linkShared: "Shared.",
    linkCopied: "Link copied.",
    copyLinkBlocked: "Could not copy link. Your browser blocked clipboard access.",
    searchHistoryPlaceholder: "Search history, contributor, scene title, or date",
    selectStorylineToViewFeedback: "Select a storyline to view feedback.",
    noCanonScenesYetAddScene1: "No canon scenes yet. Add Scene 1 using the Canon Writing Window.",
    validatedScenesSameAsReaderView: "Shows the last five validated scenes (same rule as Reader View).",
    openReaderViewForStoryline: "Open Reader View for this storyline.",
    openCanonWritingWindow: "Open the canon writing window.",
    openStorylineConstitutionAndHistory: "Open storyline constitution and history",
    modeDoesNotAllowProposalsForYou: "This mode does not allow proposals for you.",
    allTimelineEvents: "All timeline events",
    canonEvents: "Canon events",
    proposalEvents: "Proposal events",
    decisionEvents: "Decision events",
    matchingHistoryItem: "matching history item",
    matchingHistoryItems: "matching history items",
    noHistoryEntriesMatchSearch: "No history entries match your current search.",
    olderHistoryItemHidden: "older history item hidden to keep the window fast and readable.",
    olderHistoryItemsHidden: "older history items hidden to keep the window fast and readable.",
    sceneLabel: "Scene",
    canonSceneLabel: "Canon Scene",
    addedLabel: "added",
    approvedByLabel: "approved by",
    proposalApprovedIntoCanon: "Proposal approved into canon",
    proposalRoundOpened: "Proposal round opened",
    proposalRoundCurrentlyOpen: "Proposal round currently open",
    oneProposalRejected: "One proposal rejected",
    allProposalsRejectedLabel: "All proposals rejected",
    pendingProposalSingle: "pending proposal",
    pendingProposalPlural: "pending proposals",
    onlyAuthorWritesCanonScenes: "Only the author writes canon scenes.",
    externalProposalsDisabled: "External proposals are disabled.",
    sceneTooLongMessage: "This scene is {count} words. Please trim it to {max} words or fewer.",
    proposalTooLongMessage: "This proposal is {count} words. Please trim it to {max} words or fewer.",
    sceneGraceRangeMessage: "This scene is {count} words. The standard target is {recommendedMax} words, but it can be saved because it stays within the {max}-word grace range. Use this exception only when trimming would hurt clarity or readability.",
    proposalGraceRangeMessage: "This proposal is {count} words. The standard target is {recommendedMax} words, but it can be submitted because it stays within the {max}-word grace range. Use this exception only when trimming would hurt clarity or readability.",
    breakSceneIntoParagraphsTip: "Tip: break your scene into paragraphs before saving. It will read better.",
    collaborativeCanonClosedOnlyAuthor: "Collaborative Writing Mode: only the storyline author or admin can write canon scenes while proposals are closed.",
    groupCanonClosedOnlyAuthor: "Group Writing Mode: only the initiator can write canon scenes while proposals are closed. When proposals open, submit a proposal instead.",
    canonLockedWhileProposalsOpen: "While proposals are open, canon writing is locked. Approve one proposal or reject all proposals to return to canon mode.",
    failedToSaveCanonScene: "Failed to save canon scene. Please try again.",
    proposalsAlreadyOpenLong: "Proposals are already open. The round closes only when you approve the next scene or reject all proposals.",
    proposalsNowOpenWithIntent: "Proposals are now open. Readers can submit, vote, comment, and follow your Next Scene Intent.",
    proposalsNowOpen: "Proposals are now open. Readers can submit, vote, and comment.",
    writeShortDecisionNote: "Please write a short decision note before approving. Even one sentence is enough.",
    couldNotIdentifyProposal: "Could not identify the proposal. Please reopen it and try again.",
    writerRoleLabel: "Writer",
    approvedAsNextCanonSceneMessage: "Approved as next canon scene. Proposals are closed. Canon Mode is unlocked.",
    rejectedProposalNote: "Rejected a proposal.",
    proposalRemoved: "Proposal removed",
    rejectedAllProposalsRound: "Rejected all proposals for this round.",
    roundCleared: "Round cleared",
    allProposalsRejectedClosedUnlocked: "All proposals rejected. Proposals are closed. Canon Mode is unlocked.",
    nextScenesStoryline: "NextScenes Storyline",
    readAndFollow: "Read and follow",
    mentionsRecentCanon: "Mentions recent canon",
    couldNotSaveDraft: "Could not save draft",
    open: "Open",
    closed: "Closed",
    roundOpen: "Round open",
    commentSingle: "comment",
    onlyWriterCanReadFullDraft: "Only the writer can read the full draft.",
    readFullBookDraftSoFar: "Read the full book draft so far.",
    onlyWriterCanViewDecisionLog: "Only the writer can view the decision log.",
    reviewCanonDecisionsActions: "Review canon decisions and actions.",
    writeYourReply: "Write your reply…",
    failedToLoadSelectedStory: "Failed to load selected story.",
    failedToLoadStorylines: "Failed to load storylines.",
    shelfStatusFailed: "Shelf status could not be loaded.",
    missingStoryId: "Missing story id.",
    shelfAddFailed: "Shelf add failed.",
    shelfRemoveFailed: "Shelf remove failed.",
    loading: "Loading…",
    fromLabel: "From",
    selectedStoryLabel: "Selected Story",
    noSelectedStory: "No selected story.",
    loadingValidatedScenes: "Loading validated scenes…",
    validatedSceneLabel: "Validated Scene",
    writerStudioAnchor: "Stories are built carefully here. Read, write, and contribute with purpose.",

    writerConfidenceTitle: "Writer Confidence",
    writerConfidenceBody:
      "Your story remains yours. You decide what becomes Canon. Accepted contributions are recorded, and Canon scenes can later be gathered into a manuscript.",
    proposalOriginalityTitle: "Submit original work only",
    proposalOriginalityBody:
      "By submitting a proposal, you confirm that the scene is your original work or that you have the right to submit it. If approved, it may become part of the story Canon and will be recorded as an accepted contribution.",

    scenePosition: "Validated Scene {current} of {total}",
    sceneRecentContext: "You are reading the most recent validated part of this story. Only the last five validated scenes are shown here.",
    sceneOpeningContext: "You are reading how this story began.",
    prev: "Previous",
    next: "Next",
    readOpening: "Read full opening scene",

    continueReading: "Continue Reading",
  },








  fr: {
    welcome_title: "Bienvenue sur NextScenes",
    welcome_action: "Choisissez ce que vous voulez faire.",
    btn_create: "Créer une histoire",
    btn_continue: "Continuer à écrire",
    btn_explore: "Explorer les histoires",
    btn_shelf: "Voir votre bibliothèque",
    btn_close: "Fermer",
    tagline:
      "Écrivez avec conscience. Lisez avec curiosité.",

    policyLinksTitle: "Liens utiles pour auteurs et contributeurs",
    policyLinksBody:
      "Pages publiques utiles sur les droits, les contributions, la publication, le partage des bénéfices et les conditions simples.",
    policyLinksProposalTitle: "Avant de soumettre",
    policyLinksProposalBody:
      "Un rappel calme : soumettez votre propre travail original et consultez la politique des contributeurs si nécessaire.",
    foundingWritersPilotTitle: "Pilote des auteurs fondateurs",
    foundingWritersPilotBody:
      "Un espace pour les auteurs qui portent une histoire originale et veulent la faire grandir avec sérieux, visibilité et engagement des lecteurs.",
    foundingWritersPilotLink: "Découvrir le pilote",

    storylines_title: "Toutes les Storylines",
    storylines_subtitle_all:
      "Parcourez tous les livres (Storylines). Utilisez la recherche, les filtres et le tri pour explorer.",
    storylines_identity_note:
      "Une Storyline est un espace narratif vivant : l’étagère publique du livre, son chemin Canon et son invitation à lire ou à contribuer.",
    storylines_subtitle_forum: "Storylines classées dans",
    refresh: "Actualiser",
    welcome_guide: "Guide d’accueil",
    loading_list: "Chargement de la liste…",
    search_title_author: "Rechercher par titre ou auteur...",
    all_forums: "Tous les forums",
    all_writing_modes: "Tous les modes d’écriture",
    sort_recent: "Trier par : récemment mis à jour",
    sort_title: "Trier par : titre (A–Z)",
    sort_canon: "Trier par : plus de scènes canon",
    no_storylines_filters:
      "Aucune Storyline ne correspond encore à vos filtres.",
    previous: "Précédent",
    next: "Suivant",
    page: "Page",
    of: "sur",

    more: "Plus",
    lang: "Langue",
    home: "Accueil",
    storyHub: "Story Hub",
    writerStudio: "Writer Studio",
    readerView: "Reader View",
    publicSite: "Site public",
    login: "Connexion",
    createAccount: "Créer un compte",
    betaFeedback: "Retour bêta",
    logout: "Déconnexion",
    forums: "Forums",
    storylines: "Storylines",
    myShelf: "Ma bibliothèque",
    profile: "Profil",
    mystery250: "Mystery250",
    notifications: "Notifications",
    admin: "Admin",
    adminWriterReviews: "Revues des auteurs",
    english: "🇬🇧 English",
    french: "🇫🇷 Français",

    welcome_intro:
      "NextScenes comporte différents espaces de travail. Choisissez votre voie selon ce que vous souhaitez faire.",
    choose_path: "Choisissez votre voie",
    small_note: "Petite note",
    welcome_storyhub_desc:
      "Commencez une nouvelle storyline et organisez l’univers de votre histoire.",
    welcome_writer_desc:
      "Continuez à écrire, ajoutez des scènes canon ou soumettez des propositions à une histoire existante.",
    welcome_reader_desc:
      "Explorez les storylines et lisez les scènes validées.",
    welcome_note_body:
      "Si vous venez pour commencer une nouvelle histoire, utilisez Story Hub. Si vous venez pour continuer à écrire ou contribuer à une histoire, utilisez Writer Studio.",
    dont_show_greeting:
      "Je ne veux plus voir ce message d’accueil",
    open_storyhub: "Ouvrir Story Hub",
    continue_writer: "Continuer dans Writer Studio",
    open_writer: "Ouvrir Writer Studio",
    open_reader: "Ouvrir Reader View",
    signed_in_as: "Connecté en tant que",

    forum_labels: {
      "Action Forum": "Action",
      "Adventure Forum": "Aventure",
      "Children Forum": "Enfants",
      "Comedy Forum": "Comédie",
      "Crime Forum": "Crime",
      "Fantasy Forum": "Fantaisie",
      "Historical Forum": "Historique",
      "Inspirational Stories Forum": "Histoires inspirantes",
      "Mystery Forum": "Mystère",
      "Poetry Forum": "Poésie",
      "Romance Forum": "Romance",
      "Suspense / Thriller Forum": "Suspense / Thriller",
      "Science Fiction Forum": "Science-fiction",
      "Faith & Inspiration Forum": "Foi et inspiration",
      "Humour Forum": "Humour",
      "Non-Fiction Stories Forum": "Récits non romanesques",
      "Young Adult Forum": "Jeunes adultes",
      "Young Illustrators Gallery": "Galerie des jeunes illustrateurs",
      "Comics & Illustrated Stories Forum": "Bandes dessinées et récits illustrés",
      "NextScenes Originals": "Créations originales NextScenes",
      "Unclassified Forum": "Non classé",
    },

    visual_story_lane_notices: {
      "Young Illustrators Gallery": {
        title: "Galerie des jeunes illustrateurs : espace protégé",
        body:
          "La Galerie des jeunes illustrateurs est un espace protégé pour les œuvres créées par des enfants et des jeunes. Les œuvres d’enfants doivent être soumises uniquement par un parent, un tuteur, un enseignant ou un adulte autorisé. N’indiquez pas le nom complet de l’enfant, son visage, le nom de son école, son adresse, son numéro de téléphone ou tout autre détail privé permettant de l’identifier.",
        guardrail: "Les enfants créent. Les adultes soumettent. NextScenes modère.",
      },
      "Comics & Illustrated Stories Forum": {
        title: "Bandes dessinées et récits illustrés",
        body:
          "Pour les créateurs de bandes dessinées, les illustrateurs et les conteurs visuels. Cet espace est destiné aux récits illustrés, aux séries dessinées, aux planches, aux légendes et aux œuvres narratives visuelles.",
        guardrail: "",
      },
      "NextScenes Originals": {
        title: "Créations originales NextScenes",
        body:
          "Pour les projets sélectionnés ou créés par NextScenes, y compris les séries dessinées mises en avant, les expérimentations officielles et les œuvres créatives choisies.",
        guardrail: "",
      },
    },

    sceneIllustrationOptional: "Illustration de scène facultative",
    sceneIllustrationPendingNotice:
      "Les illustrations sont d’abord enregistrées pour vérification. Elles ne s’affichent pas publiquement tant qu’elles ne sont pas approuvées par le propriétaire de l’histoire ou un administrateur.",
    sceneIllustrationConsentLine:
      "En ajoutant une illustration, vous confirmez avoir l’autorisation de l’utiliser.",
    sceneIllustrationPolicyLink: "Politique sur les illustrations",
    coverUploadLabel: "Téléverser une couverture",
    coverUploadHint: "JPG, PNG ou WEBP. Maximum 5 MB.",
    coverUploadButton: "Téléverser la couverture",
    coverUploading: "Téléversement…",
    coverUploadSuccess: "Couverture téléversée. L’URL a été ajoutée au champ de couverture.",
    illustrationApprovalGuardrail:
      "Approuvez seulement les illustrations adaptées, légales et liées à la scène.",
    sceneIllustrationUrl: "URL de l’image d’illustration",
    sceneIllustrationCaption: "Légende",
    sceneIllustrationCredit: "Artiste / crédit",
    sceneIllustrationAltText: "Texte alternatif pour l’accessibilité",
    sceneIllustrationLabel: "Illustration de scène",
    sceneIllustrationPending: "En attente de vérification",
    sceneIllustrationApproved: "Approuvée",
    sceneIllustrationRejected: "Rejetée",
    sceneIllustrationReviewReason: "Raison",
    sceneIllustrationReviewNote: "Note",
    sceneIllustrationReasonDoesNotMatch: "Ne correspond pas à la scène",
    sceneIllustrationReasonImageQuality: "Qualité d’image insuffisante",
    sceneIllustrationReasonConsentCopyright: "Problème de consentement ou de droit d’auteur",
    sceneIllustrationReasonSafetyPolicy: "Problème de sécurité ou de politique",
    sceneIllustrationReasonOther: "Autre",
    sceneIllustrationHelpSummary: "Règles et vérification",
    sceneIllustrationFileHelpSummary: "Aide fichier",
    sceneIllustrationReviewPanel: "Vérification de l’illustration",
    sceneIllustrationReviewAction: "Action de vérification",
    sceneIllustrationApproveButton: "Approuver l’illustration",
    sceneIllustrationRejectButton: "Rejeter l’illustration",
    sceneIllustrationClearButton: "Effacer l’illustration",
    sceneIllustrationChooseReason: "Choisir une raison",
    sceneIllustrationRejectNotePlaceholder: "Note facultative pour le contributeur…",
    sceneIllustrationRejectionReasonRequired: "Veuillez choisir une raison de rejet.",
    sceneIllustrationReviewSaved: "Vérification de l’illustration enregistrée.",
    sceneIllustrationReviewFailed: "La vérification de l’illustration a échoué. Veuillez réessayer.",
    sceneIllustrationConfirmLabel: "Je confirme que c’est la bonne illustration pour cette scène.",
    sceneIllustrationConfirmRequired: "Veuillez confirmer cette illustration avant de continuer.",

    writing_mode_labels: {
      Solo: "Solo",
      Collaborative: "Collaboratif",
      "Group (Open)": "Groupe (ouvert)",
      "Group (Closed)": "Groupe (fermé)",
    },

    card_by: "Par",
    card_storyline_fallback: "Storyline",
    card_story: "Histoire",
    card_unknown_author: "Auteur inconnu",
    card_untitled_story: "Histoire sans titre",
    card_a_nextscenes_story: "Une histoire NextScenes",
    card_created: "Créé",
    card_last_updated: "Dernière mise à jour",
    card_created_unknown: "Créé : inconnu",
    card_tooltip_created: "Créé",
    card_tooltip_updated: "Mis à jour",
    card_canon: "canon",
    card_canon_scene_singular: "scène canon",
    card_canon_scene_plural: "scènes canon",

    breadcrumb_home: "ACCUEIL",
    breadcrumb_forums: "FORUMS",
    breadcrumb_storylines: "STORYLINES",

    btn_writer_room: "Salle d’écriture",
    btn_reader_view: "Lecture",
    btn_continue_updated: "Continuer · Mis à jour",
    btn_continue_only: "Continuer",
    btn_save_to_shelf: "Enregistrer",
    btn_view_on_amazon: "Voir sur Amazon",
    status_published_amazon: "Publié sur Amazon",
    status_preview_on_nextscenes: "Aperçu sur NextScenes",
    status_published_book: "Livre publié",
    status_published_preview: "Aperçu publié",
    status_completed_book: "Livre terminé",
    status_completed_preview: "Aperçu terminé",
    btn_view_published_book: "Voir le livre publié",
    btn_view_book: "Voir le livre",
    status_in_development: "En développement",
    status_not_published: "Non encore publié",
    btn_saved: "Enregistré ✓",
    btn_saving: "Enregistrement…",
    btn_opening: "Ouverture…",
    btn_login_to_write: "Se connecter pour écrire",

    title_show_welcome_again:
      "Afficher de nouveau le guide d’accueil",
    title_open_reader_view: "Ouvrir Reader View",
    title_login_required_writer_studio:
      "Connexion requise pour entrer dans Writer Studio.",
    title_enter_writer_studio:
      "Entrer dans Writer Studio.",
    title_save_storyline_to_shelf:
      "Enregistrer cette storyline dans votre bibliothèque.",
    title_login_required_shelf:
      "Connexion requise pour enregistrer dans la bibliothèque.",
    title_view_profile: "Voir le profil de",

    feedback_tracking_load_failed:
      "Le suivi n’a pas pu être chargé.",
    feedback_login_required_shelf:
      "Connexion requise pour enregistrer dans la bibliothèque.",
    feedback_removed_from_shelf:
      "Retiré de la bibliothèque.",
    feedback_saved_to_shelf:
      "Enregistré dans la bibliothèque ✓",
    feedback_shelf_action_failed:
      "L’action sur la bibliothèque a échoué. Veuillez réessayer.",
    feedback_login_required_writer_room:
      "Connexion requise pour entrer dans la salle d’écriture.",
    feedback_opening_writer_room:
      "Ouverture de la salle d’écriture…",
    feedback_opening_reader_view:
      "Ouverture de Reader View…",
    alert_login_first:
      "Veuillez vous connecter d’abord.",

    aboutAuthorTitle: "À propos de l’auteur",
    descriptionPlaceholderShort:
      "Une courte description de cette histoire...",
    alertWriterFallback:
      "Ouvrez Writer Studio depuis le menu du haut, puis sélectionnez cette histoire.",
    alertReaderFallback:
      "Ouvrez Reader View depuis le menu du haut, puis sélectionnez cette histoire.",

    writerStudioTitle: "Writer Studio",
    writerStudioLocked:
      "Cet espace est verrouillé. Vous devez vous connecter pour accéder à Writer Studio.",
    goToLogin: "Aller à la connexion",
    backToStorylines: "Retour aux Storylines",

    close: "Fermer",
    cancel: "Annuler",
    back: "Retour",
    welcome: "Bienvenue",
    clear: "Effacer",
    unknown: "Inconnu",
    general: "Général",

    draftRestored: "Brouillon restauré",
    draftSaved: "Brouillon enregistré",
    autosaved: "Enregistré automatiquement",
    draftCleared: "Brouillon effacé",

    commentWriterBlocked:
      "L’auteur ne peut pas commenter dans les retours des lecteurs.",
    commentUsernameRequired:
      "Vous devez être connecté pour commenter.",
    commentUsernameRequiredReply:
      "Vous devez être connecté pour commenter.",
    commentEmpty:
      "Le commentaire ne peut pas être vide.",
    commentPosted: "Commentaire publié.",
    commentFailed:
      "Échec de la publication du commentaire.",

    replyWriterBlocked:
      "L’auteur ne peut pas répondre ici.",
    replyUsernameRequired:
      "Vous devez être connecté pour répondre.",
    replyEmpty: "La réponse ne peut pas être vide.",
    replyPosted: "Réponse publiée.",
    replyFailed:
      "Échec de la publication de la réponse.",

    readerViewTitle: "Reader View",
    readerViewSubtitle:
      "Les invités peuvent lire. Explorez les Storylines, découvrez chaque histoire et consultez les cinq dernières scènes validées.",
    readerViewGuidanceGuest:
      "Astuce : Cliquez sur une Storyline pour voir les détails. Utilisez les cinq dernières scènes validées pour découvrir l’écriture. Connectez-vous pour enregistrer et participer.",
    readerViewGuidanceUser:
      "Astuce : Cliquez sur une Storyline pour l’ouvrir. Utilisez les cinq dernières scènes validées pour lire rapidement. Enregistrez-la dans votre bibliothèque si vous souhaitez la conserver.",
    trackingLastOpenedLabel: "Continuité de lecture",
    trackingLastOpened: "Dernière ouverture {time}",
    trackingLastOpenedHelper:
      "NextScenes garde en mémoire votre dernier passage dans cette storyline.",
    trackingNotOpenedYet: "Pas encore ouvert",
    trackingLoading: "Mise à jour de la continuité…",
    sceneRatingPrompt: "Votre avis",
    sceneRatingSaved: "Enregistré.",
    sceneRatingGuestSaved: "Enregistré comme invité.",
    sceneRatingSaving: "Enregistrement…",
    sceneRatingError: "Non enregistré.",
    sceneRatingAria: "Noter cette scène {rating} sur 5",
    sceneRatingCurrent: "Votre note : {rating}/5",
    sceneRatingSummaryLabel: "Réponse des lecteurs",
    sceneRatingSummaryEmpty: "Soyez parmi les premiers à noter cette scène.",
    sceneRatingSummarySingular: "{count} note de lecteur",
    sceneRatingSummaryPlural: "{count} notes de lecteurs",
    sceneRatingSummaryAria: "Note moyenne {average} sur 5, basée sur {count} notes",
    sceneReactionPrompt: "Qu’avez-vous ressenti ?",
    sceneReactionSaved: "Réaction enregistrée.",
    sceneReactionGuestSaved: "Réaction enregistrée comme invité.",
    sceneReactionSaving: "Enregistrement de la réaction…",
    sceneReactionError: "Réaction non enregistrée.",
    sceneReactionAria: "Choisir la réaction : {reaction}",
    sceneReactionCurrent: "{count} réaction sélectionnée.",
    sceneReactionLabels: {
      want_more: "Je veux la suite",
      exciting: "Passionnant",
      emotional: "Émouvant",
      like_character: "J’aime ce personnage",
      confusing: "Confus",
      too_long: "Trop long",
      afraid_for_character: "J’ai peur pour ce personnage",
      curious_ending: "Fin intrigante",
    },
    readerSignals: "Signaux lecteurs",
    readerSignalsWaiting: "En attente",
    readerSignalsSingular: "{count} signal",
    readerSignalsPlural: "{count} signaux",
    readerCopyProtectionNotice: "Lecture protégée : copie désactivée.",

    searchPlaceholder:
      "Rechercher titre, auteur, forum, mode…",
    filterByMode: "Filtrer par mode d’écriture",
    allModes: "Tous les modes",
    collaborative: "Collaboratif",
    solo: "Solo",
    groupOpen: "Groupe ouvert",
    groupClosed: "Groupe fermé",
    clearSearch: "Effacer la recherche",
    showing: "Affichage",
    matched: "résultats",
    noStorylinesFound:
      "Aucune storyline ne correspond à votre recherche.",

    writingModeLabel: "Mode d’écriture",
    by: "Par",
    openStorylineHint:
      "Ouvrez pour voir les détails et les scènes validées.",
    lastFiveScenes: "Cinq dernières scènes validées",
    selected: "Sélectionné",

    storylineInformation:
      "Informations sur la storyline",
    dateTimeCreated: "Date et heure de création",
    lastUpdated: "Dernière mise à jour",
    validatedScenes: "Scènes validées",
   
    description: "Description",
    aboutTheAuthor: "À propos de l’auteur",
    synopsis: "Synopsis",
    noDescriptionYet:
      "Aucune description pour le moment.",
    noAuthorBioYet:
      "Biographie de l’auteur non fournie pour le moment.",
    noSynopsisYet:
      "Synopsis non fourni pour le moment.",
    loginToParticipate: "Connexion pour participer",
    readersShapeFuture:
      "Les lecteurs façonnent l’avenir ici.",
    readerGuestInvite:
      "Connectez-vous pour utiliser la bibliothèque, proposer la scène suivante, voter sur les propositions des lecteurs et rejoindre les discussions.",
    loginToUseShelf:
      "Connexion pour utiliser la bibliothèque",
    shelf: "Bibliothèque",
    checking: "Vérification…",
    removeFromShelf:
      "Retirer de la bibliothèque",
    saveToShelf:
      "Enregistrer dans la bibliothèque",
    checkingShelf:
      "Vérification de la bibliothèque…",
    onMyShelf: "Dans ma bibliothèque",
    notOnShelf: "Pas dans la bibliothèque",
    soloWriting: "Écriture solo",
    collaborativeWriting: "Écriture collaborative",
    groupWritingOpen:
      "Écriture de groupe (ouverte)",
    groupWritingClosed:
      "Écriture de groupe (fermée)",

    unclassifiedForum: "Forum non classé",
    filterAll: "Toutes les histoires",
    shortStoryLabel: "Nouvelle",
    storyType: "Type d’histoire",

    writerAccessTitle: "Accès Écrivain",
    writerAccessLoginRequired:
      "Vous devez être connecté pour demander l’accès Écrivain.",
    requestSubmitted:
      "Demande soumise. Un administrateur l’examinera.",
    requestFailed:
      "Échec de l’envoi de la demande.",

    writerStudioSubtitle:
      "Choisissez une histoire, rédigez des scènes canon, examinez les propositions et suivez les retours des lecteurs en un seul endroit.",
    noStorylinesMessage:
      "Aucune histoire disponible pour le moment. Créez-en une dans Story Hub, puis revenez dans l’Espace Écrivain.",
    searchFilters: "Recherche et filtres",
    clearFiltersTitle:
      "Effacer la recherche et les filtres",
    selectStorylineInstruction:
      "Sélectionnez une storyline pour entrer dans le Writer Studio.",

    writerStudioCurrentState: "ÉTAT ACTUEL",
    writerStudioCanonMode: "Mode canon",
    writerStudioCanonModeDesc:
      "L’auteur façonne l’histoire officielle. Les propositions sont fermées.",
    writerStudioProposalRoundOpen:
      "Cycle de propositions ouvert",
    writerStudioProposalRoundOpenDesc:
      "Les lecteurs façonnent la prochaine scène.",
    writerStudioActivitySummary:
      "RÉSUMÉ D’ACTIVITÉ",
    writerStudioCanon: "Canon",
    writerStudioProposals: "Propositions",
    writerStudioComments: "Commentaires",
    writerStudioReplies: "Réponses",
    writerStudioVotes: "Votes",

    writerStudioShareStoryline:
      "Partager la storyline",
    writerStudioReadFullBookDraft:
      "Lire le brouillon complet du livre",
    writerStudioFullBookDraft:
      "Brouillon complet du livre",
    writerStudioFullBookDraftDesc:
      "Vue réservée à l’auteur de l’ensemble du canon jusqu’ici.",
    writerStudioDownloadDraftTxt:
      "Télécharger le brouillon (.txt)",

    writerStudioDecisionLog:
      "Journal des décisions",
    writerStudioDecisionLogDesc:
      "Un court relevé des approbations, rejets et réinitialisations de cycle.",
    writerStudioNoDecisionsYet:
      "Aucune décision enregistrée pour le moment.",

    writerStudioReaderView: "Vue lecteur",
    writerStudioRecentCanonSnippets:
      "SCÈNES CANON RÉCENTES (EXTRAITS)",
    writerStudioViewValidatedScenes:
      "Voir les scènes validées",
    writerStudioValidatedCanonScenes:
      "Scènes canon validées",
    writerStudioProposalsOpenLabel:
      "Propositions ouvertes",
    writerStudioValidatedCanonScenesDesc:
      "Affiche seulement les cinq dernières scènes validées, comme dans la Vue lecteur.",

    writerStudioCallForProposedScenes:
      "Lancer l’appel à propositions",
    writerStudioOpenProposalRound:
      "Ouvrir le cycle de propositions",
    writerStudioOpenProposalRoundDesc:
      "Facultatif : écrivez une brève intention pour la scène suivante afin de guider les lecteurs.",
    writerStudioNextSceneIntentOptional:
      "Intention pour la scène suivante (facultatif)",
    writerStudioOpenProposals:
      "Ouvrir les propositions",

    writerStudioWritingWindows:
      "FENÊTRES D’ÉCRITURE",
    writerStudioWhereWorkHappens:
      "Là où le travail se fait.",
    writerStudioMode: "Mode",
    writerStudioState: "État",
    writerStudioWriteCanonOrOpenRound:
      "Écrivez ici la prochaine scène canonique ou ouvrez le cycle suivant si ce mode l’autorise.",
    writerStudioReadersCanSubmitProposals:
      "Les lecteurs peuvent soumettre des propositions. Quand vous êtes prêt, examinez-les et approuvez la meilleure pour en faire la prochaine scène canonique.",
    writerStudioCanonLockedNotWriter:
      "Vous n’êtes pas l’auteur de cette storyline, donc l’écriture canonique est verrouillée.",
    writerStudioAddCanonSceneWindow:
      "Ajouter une scène canonique (fenêtre)",
    writerStudioAddCanonScene:
      "Ajouter une scène canonique",
    writerStudioSubmitProposalWindow:
      "Soumettre une proposition (fenêtre)",
    writerStudioKeepReadable:
      "Gardez votre texte entre 200 et 500 mots. Utilisez des paragraphes pour une lecture plus fluide.",
    writerStudioStatus: "Statut",
    writerStudioWaiting: "En attente",
    writerStudioWordCount:
      "Nombre de mots",
    writerStudioShortParagraphTip:
      "Astuce : écrivez en courts paragraphes. Si le texte paraît trop serré, appuyez sur Entrée pour créer un nouveau paragraphe avant d’enregistrer.",
    writerStudioSceneTitle:
      "Titre de la scène",
    writerStudioSceneText:
      "Texte de la scène",
    writerStudioGenerateTestText:
      "Générer un texte test",
    writerStudioSaveCanonScene:
      "Enregistrer la scène canonique",

    writerStudioSubmitProposal:
      "Soumettre une proposition",
    writerStudioKeepParagraphsHelp:
      "Gardez votre texte entre 200 et 500 mots. Les paragraphes aident.",
    writerStudioProposalTitle:
      "Titre de la proposition.",
    writerStudioProposedSceneText:
      "Texte de la scène proposée.",
    writerStudioSaveAsDraft:
      "Enregistrer comme brouillon",
    writerStudioClearSavedDraft:
      "Effacer le brouillon enregistré",

    writerStudioStoryInfoButton:
      "Infos sur l’histoire",
    writerStudioStoryInfo:
      "Infos sur l’histoire",
    writerStudioStoryInfoDesc:
      "Gouvernance et historique de cette storyline. Recherchez des événements, contributeurs et titres de scènes.",
    writerStudioSearchHistory:
      "Rechercher dans l’historique, les contributeurs ou les dates",
    writerStudioAllHistory:
      "Tout l’historique",
    writerStudioShowingMatchingHistoryItems:
      "Affichage des éléments d’historique correspondants.",
    writerStudioStoryConstitution:
      "Constitution de l’histoire",
    writerStudioWritingMode:
      "Mode d’écriture",
    writerStudioCollaborativeWriting:
      "Écriture collaborative",
    writerStudioStoryOwner:
      "Auteur principal",
    writerStudioCanonAuthority:
      "Autorité du canon",
    writerStudioContributionType:
      "Type de contribution",
    writerStudioProposalsOpenOnlyWhenAuthorOpens:
      "Les propositions sont ouvertes uniquement lorsque l’auteur les active.",
    writerStudioCurrentMode:
      "Mode actuel",
    writerStudioParticipation:
      "Participation",
    writerStudioRegisteredWritersMaySubmit:
      "Les auteurs inscrits peuvent proposer durant les cycles ouverts.",
    writerStudioCanonProtection:
      "Protection du canon",
    writerStudioApprovedScenesPermanent:
      "Les scènes validées deviennent permanentes.",
    writerStudioStoryOwnerValue:
      "Auteur principal",

    writerStudioStoryHistory:
      "Historique de l’histoire",
    writerStudioScrollableProvenance:
      "Chronologie défilante de provenance.",
    writerStudioCanonSceneAdded:
      "Scène canonique ajoutée.",
    writerStudioStoryCreated:
      "Histoire créée.",

    writerStudioProposedScenesNextRound:
      "SCÈNES PROPOSÉES (CYCLE DE SCÈNE SUIVANTE)",
    writerStudioProposalLabel:
      "Proposition",
    writerStudioGood: "Bonne",
    writerStudioIncompatible:
      "Incompatible",
    writerStudioNeutral: "Neutre",
    writerStudioViewFullProposal:
      "Voir la proposition complète",
    writerStudioApproveAsNextScene:
      "Approuver comme scène suivante",
    writerStudioRejectProposal:
      "Rejeter la proposition",
    writerStudioRejectAllProposals:
      "Rejeter toutes les propositions",
    writerStudioAllProposalsRejected:
      "Toutes les propositions ont été rejetées. Les propositions sont fermées. Le mode canon est réactivé.",
    writerStudioNoProposalsYet:
      "Les propositions sont ouvertes, mais aucune n’a été soumise.",

    writerStudioReaderFeedback:
      "RETOURS DES LECTEURS",
    writerStudioProposalRound:
      "Cycle de propositions",
    writerStudioReaderFeedbackDesc:
      "Les lecteurs peuvent publier des commentaires et des réponses. L’auteur ne peut pas commenter ici.",
    writerStudioPostAComment:
      "Publier un commentaire.",
    writerStudioShareYourFeedback:
      "Partagez votre avis.",
    writerStudioRepliesStayUnder:
      "Les réponses restent sous le commentaire auquel elles répondent.",
    writerStudioPostComment:
      "Publier le commentaire",
    writerStudioWritersCannotCommentPlaceholder:
      "Les auteurs ne peuvent pas commenter.",

    writerStudioProposalsClosedCallNextRound:
      "Les propositions sont fermées. L’auteur peut lancer un appel à propositions pour ouvrir le cycle suivant.",

    writerStudioClosedGroupCommentReplyOnly:
      "Groupe fermé. Seuls les membres peuvent interagir.",
    writerStudioGroupCommentReplyOnly:
      "Seuls les participants peuvent interagir ici.",
    writerStudioGroupOwnerProposalsOpen:
      "Le propriétaire du groupe contrôle les propositions.",
    writerStudioGroupAcceptedMembersMayContribute:
      "Les membres approuvés peuvent contribuer.",
    writerStudioClosedGroupOwnerProposalsOpen:
      "Le propriétaire contrôle les propositions en mode fermé.",
    writerStudioOnlyInvitedGroupMembersMayContribute:
      "Seuls les membres invités peuvent contribuer.",
    writerStudioCanonLockedUntilDecision:
      "Le canon est verrouillé jusqu’à décision.",

    currentState: "ÉTAT ACTUEL",
    canonMode: "Mode canon",
    canonModeDesc:
      "L’auteur façonne l’histoire officielle. Les propositions sont fermées.",
    proposalRoundOpen:
      "Cycle de propositions ouvert",
    proposalRoundOpenDesc:
      "Les lecteurs façonnent la prochaine scène. Le canon est verrouillé jusqu’à décision de l’auteur.",

    activitySummary: "RÉSUMÉ D’ACTIVITÉ",
    canon: "Canon",
    proposals: "Propositions",
    comments: "Commentaires",
    replies: "Réponses",
    votes: "Votes",

    shareStoryline:
      "Partager la storyline",
    readFullDraft:
      "Lire le brouillon complet",
    fullBookDraft:
      "Brouillon complet du livre",
    writerOnlyView:
      "Vue réservée à l’auteur du canon actuel.",
    downloadDraft:
      "Télécharger le brouillon (.txt)",

    decisionLog:
      "Journal des décisions",
    decisionLogDesc:
      "Historique des validations, rejets et cycles.",
    noDecisions:
      "Aucune décision enregistrée pour le moment.",

    recentCanonScenes:
      "SCÈNES CANON RÉCENTES (EXTRAITS)",
    viewValidatedScenes:
      "Voir les scènes validées",
    validatedCanonScenes:
      "Scènes canon validées",
    
    validatedScenesNote:
      "Affiche uniquement les cinq dernières scènes validées.",

    callForProposals:
      "Appel à propositions",
    openProposalRound:
      "Ouvrir le cycle de propositions",
    nextSceneIntentLabel:
      "Orientation de la prochaine scène (optionnel)",
    nextSceneIntentPlaceholder:
      "Indiquez une direction pour guider les lecteurs...",
    openProposals:
      "Ouvrir les propositions",

    writingWindows:
      "ESPACES D’ÉCRITURE",
    whereWorkHappens:
      "Là où le travail prend forme.",
    mode: "Mode",
    state: "État",
    proposalRoundOpenShort:
      "Cycle ouvert",
    writeCanonInstruction:
      "Écrivez la prochaine scène canon ici ou ouvrez un nouveau cycle si ce mode le permet.",
    proposalInstruction:
      "Les lecteurs peuvent soumettre des propositions. Lorsque vous êtes prêt, approuvez la meilleure.",
    canonLocked:
      "Vous n’êtes pas l’auteur de cette storyline. L’écriture canon est verrouillée.",
    addCanonScene:
      "Ajouter une scène canon (fenêtre)",
    submitProposalWindow:
      "Soumettre une proposition (fenêtre)",

    sceneTitle:
      "Titre de la scène",
    sceneText:
      "Texte de la scène",
    generateTestText:
      "Générer un texte de test",
    saveCanonScene:
      "Enregistrer la scène canon",
    wordCount:
      "Nombre de mots",
    status: "Statut",
    waiting:
      "En attente",
    writingTip:
      "Astuce : utilisez des paragraphes courts pour une meilleure lisibilité.",

    proposalTitle:
      "Titre de la proposition",
    proposalText:
      "Texte de la scène proposée",
    saveDraft:
      "Enregistrer comme brouillon",
    clearDraft:
      "Effacer le brouillon",
    submitProposalBtn:
      "Soumettre la proposition",

    storyInfo:
      "Infos sur l’histoire",
    storyInfoDesc:
      "Gouvernance et historique de cette storyline.",
    searchHistory:
      "Rechercher dans l’historique",
    allHistory:
      "Tout l’historique",
    showingResults:
      "Affichage des éléments correspondants",
    storyConstitution:
      "Constitution de l’histoire",
    writingMode:
      "Mode d’écriture",
    storyOwner:
      "Auteur principal",
    canonAuthority:
      "Autorité du canon",
    contributionType:
      "Type de contribution",
    proposalRule:
      "Les propositions sont ouvertes uniquement lorsque l’auteur les active.",
    currentMode:
      "Mode actuel",
    participation:
      "Participation",
    participationRule:
      "Les auteurs inscrits peuvent proposer durant les cycles ouverts.",
    canonProtection:
      "Protection du canon",
    canonProtectionRule:
      "Les scènes validées deviennent permanentes.",

    storyHistory:
      "Historique de l’histoire",
    timelineDesc:
      "Chronologie des événements",
    canonSceneAdded:
      "Scène canon ajoutée",
    storyCreated:
      "Histoire créée",

    proposedScenes:
      "SCÈNES PROPOSÉES (PROCHAIN CYCLE)",
    proposal:
      "Proposition",
    good: "Bonne",
    incompatible:
      "Incompatible",
    neutral:
      "Neutre",
    viewFullProposal:
      "Voir la proposition complète",
    approveNextScene:
      "Approuver comme prochaine scène",
    rejectProposal:
      "Rejeter la proposition",
    rejectAll:
      "Rejeter toutes les propositions",
    allRejected:
      "Toutes les propositions ont été rejetées. Le mode canon est réactivé.",
    noProposalsYet:
      "Les propositions sont ouvertes, mais aucune n’a été soumise.",

    readerFeedback:
      "RETOURS DES LECTEURS",
    stateLabel:
      "État",
    proposalRound:
      "Cycle de propositions",
    feedbackRule:
      "Les lecteurs peuvent commenter et répondre. L’auteur ne peut pas intervenir ici.",
    postComment:
      "Publier un commentaire",
    shareFeedback:
      "Partagez votre avis",
    replyStructure:
      "Les réponses restent attachées au commentaire d’origine.",
    postCommentBtn:
      "Publier",

    submitProposalModalTitle:
      "Soumettre une proposition",
    submitProposalModalDesc:
      "Longueur recommandée : {min} à {recommendedMax} mots. Une courte exception jusqu’à {max} mots est autorisée lorsque la lisibilité l’exige. Les paragraphes aident.",

    addCanonModalTitle:
      "Ajouter une scène canon",
    addCanonModalDesc:
      "Rédigez une scène claire et bien structurée.",
    canonLengthGuidance:
      "Longueur recommandée : {min} à {recommendedMax} mots. Une courte exception jusqu’à {max} mots est autorisée lorsque la lisibilité l’exige.",

    historyLoadMore:
      "Charger plus",
    historyShowing:
      "Affichage",
    historyOf:
      "sur",
    historyEntries:
      "éléments",

    submitProposalModalDescStart:
      "Longueur recommandée :",
    and: "et",
    words: "mots.",
    paragraphsHelp:
      "Les paragraphes aident.",
    
    addParagraphBreaks: "Ajoutez des sauts de paragraphe",

    noValidatedScenesYet: "Aucune scène validée pour le moment.",
    waitingForProposals: "En attente de propositions",

   

    proposalsDisabledSolo: "Mode écriture solo : les propositions sont désactivées.",
   onlyWriterCanOpenProposals: "Seul l’auteur de la storyline peut ouvrir les propositions.",
   proposalsAlreadyOpen: "Les propositions sont déjà ouvertes.",
   openNextSceneRound: "Ouvrir le prochain cycle de scène pour les lecteurs.",
   proposalsOpen: "Propositions ouvertes",

   postReply: "Publier la réponse",

   reply: "Répondre",
   closeReply: "Fermer la réponse",

   saving: "Enregistrement…",

   submitting: "Soumission…",

   
   openProposalRoundDesc: "Facultatif : écrivez une brève intention pour guider les lecteurs.",
  

   decisionNoteRequired: "Note de décision requise",
   decisionNoteDesc: "Rédigez une courte justification pour approuver cette proposition comme canon.",
   approving: "Validation de",
   untitledProposal: "Proposition sans titre",
   decisionNoteLabel: "Note de décision",

   approveAsCanon: "Approuver comme canon",

   writerOnlyAccess: "Seul l’auteur peut voir ceci.",
   noCanonYet: "Aucun canon pour le moment.",

  loadMore: "Charger plus",
  showAllVisible: "Afficher tout",
  collapse: "Réduire",

  historyPerformanceNote:
  "Pour des raisons de performance, cette fenêtre affiche jusqu’à {max} éléments filtrés à la fois. Utilisez la recherche ou les filtres pour réduire les historiques très volumineux.",

  fullProposal: "Proposition complète",

  nextSceneIntentFromWriter: "Intention de la prochaine scène (de l’auteur)",

  author: "Auteur",
  forum: "Forum",

  tooLong: "Trop long",
tooShort: "Trop court",
addParagraphs: "Ajoutez des paragraphes",
needsTightening: "À resserrer",
notReady: "Pas prêt",
allowedException: "Exception autorisée",

ownersManageProposals: "Les propriétaires gèrent les propositions; ils ne les soumettent pas.",
closedGroupOnlyInvited: "Ceci est une histoire de groupe fermée. Seuls les membres invités peuvent contribuer.",
groupOnlyInvited: "Ceci est une histoire de groupe. Seuls les membres invités peuvent soumettre et voir les propositions.",
collabRequiresWriterAccount: "Les propositions collaboratives nécessitent un compte Écrivain.",
proposalsClosedWaitWriter: "Les propositions sont fermées. Attendez que l’auteur ouvre le cycle.",

preparingWorkspace: "Préparation de votre espace de travail…",
restoringSession: "Restauration de la session et chargement des storylines.",
pleaseWait: "Veuillez patienter…",
 
    
    storiesLoadFailed: "Impossible de joindre le serveur. Aucune storyline n’a été chargée.",
    provideSceneTitle: "Veuillez donner un titre à la scène.",
    writeSceneText: "Veuillez écrire le texte de la scène.",
    onlyWriterCanAddCanonScenes: "Seul l’auteur de la storyline peut ajouter des scènes canon.",
    soloAuthorOnlyCanon: "Le mode solo est réservé à l’auteur. Vous ne pouvez pas ajouter une scène canon à une histoire solo que vous n’avez pas créée.",
    sceneAlreadySaved: "Cette scène est déjà enregistrée. Modifiez-la avant de l’enregistrer à nouveau.",
    canonSceneSavedValidated: "Scène canon enregistrée et validée.",
    onlyWriterCanCallProposals: "Seul l’auteur de la storyline peut ouvrir un appel à propositions.",
    proposalsDisabledForStoryline: "Mode d’écriture solo : les propositions sont désactivées pour cette storyline.",
    failedToOpenProposals: "Impossible d’ouvrir les propositions. Veuillez réessayer.",
    provideClearerTitle: "Veuillez donner un titre plus clair d’au moins 6 caractères.",
    writeProposedSceneText: "Veuillez écrire le texte de la scène proposée.",
    mainWriterCannotSubmitProposals: "En tant qu’auteur principal, vous ne pouvez pas soumettre de propositions. Les lecteurs proposent, vous décidez.",
    writerHasNotOpenedProposalRound: "L’auteur n’a pas encore ouvert ce tour de propositions.",
    proposedSceneSubmitted: "Scène proposée soumise pour cette storyline.",
    failedToSubmitProposal: "Impossible de soumettre la proposition. Veuillez réessayer.",
    onlyWriterCanApproveProposals: "Seul l’auteur de la storyline peut approuver des scènes proposées.",
    failedToApproveProposal: "Impossible d’approuver la proposition. Veuillez réessayer.",
    onlyWriterCanRejectProposals: "Seul l’auteur de la storyline peut rejeter des scènes proposées.",
    proposedSceneRejectedRemoved: "Scène proposée rejetée et supprimée.",
    failedToRejectProposal: "Impossible de rejeter la proposition. Veuillez réessayer.",
    onlyWriterCanRejectAllProposals: "Seul l’auteur de la storyline peut rejeter toutes les scènes proposées.",
    failedToRejectAllProposals: "Impossible de rejeter toutes les propositions. Veuillez réessayer.",
    votingOnlyWhenProposalsOpen: "Le vote n’est disponible que lorsque les propositions sont ouvertes.",
    writerCannotVoteOnProposals: "L’auteur ne peut pas voter sur les propositions.",
    setUsernameBeforeVoting: "Veuillez définir un nom d’utilisateur avant de voter.",
    cannotVoteOwnProposal: "Vous ne pouvez pas voter pour votre propre scène proposée.",
    alreadyVotedOnProposal: "Vous avez déjà voté pour cette proposition.",
    voteRecorded: "Votre vote a été enregistré.",
    linkShared: "Partagé.",
    linkCopied: "Lien copié.",
    copyLinkBlocked: "Impossible de copier le lien. Votre navigateur a bloqué l’accès au presse-papiers.",
    searchHistoryPlaceholder: "Rechercher dans l’historique, les contributeurs, le titre de scène ou la date",
    selectStorylineToViewFeedback: "Sélectionnez une storyline pour voir les retours.",
    noCanonScenesYetAddScene1: "Aucune scène canon pour le moment. Ajoutez la scène 1 dans la fenêtre d’écriture canon.",
    validatedScenesSameAsReaderView: "Affiche uniquement les cinq dernières scènes validées, comme dans Reader View.",
    openReaderViewForStoryline: "Ouvrir Reader View pour cette storyline.",
    openCanonWritingWindow: "Ouvrir la fenêtre d’écriture canon.",
    openStorylineConstitutionAndHistory: "Ouvrir la constitution et l’historique de la storyline",
    modeDoesNotAllowProposalsForYou: "Ce mode ne vous autorise pas à proposer ici.",
    allTimelineEvents: "Tous les événements de la chronologie",
    canonEvents: "Événements canon",
    proposalEvents: "Événements de proposition",
    decisionEvents: "Événements de décision",
    matchingHistoryItem: "élément d’historique correspondant",
    matchingHistoryItems: "éléments d’historique correspondants",
    noHistoryEntriesMatchSearch: "Aucune entrée d’historique ne correspond à votre recherche actuelle.",
    olderHistoryItemHidden: "ancien élément d’historique masqué pour garder la fenêtre rapide et lisible.",
    olderHistoryItemsHidden: "anciens éléments d’historique masqués pour garder la fenêtre rapide et lisible.",
    sceneLabel: "Scène",
    canonSceneLabel: "Scène canon",
    addedLabel: "ajoutée",
    approvedByLabel: "approuvée par",
    proposalApprovedIntoCanon: "Proposition approuvée dans le canon",
    proposalRoundOpened: "Tour de propositions ouvert",
    proposalRoundCurrentlyOpen: "Tour de propositions actuellement ouvert",
    oneProposalRejected: "Une proposition rejetée",
    allProposalsRejectedLabel: "Toutes les propositions rejetées",
    pendingProposalSingle: "proposition en attente",
    pendingProposalPlural: "propositions en attente",
    onlyAuthorWritesCanonScenes: "Seul l’auteur écrit les scènes canon.",
    externalProposalsDisabled: "Les propositions externes sont désactivées.",
    sceneTooLongMessage: "Cette scène contient {count} mots. Veuillez la réduire à {max} mots ou moins.",
    proposalTooLongMessage: "Cette proposition contient {count} mots. Veuillez la réduire à {max} mots ou moins.",
    sceneGraceRangeMessage: "Cette scène contient {count} mots. La cible standard est de {recommendedMax} mots, mais elle peut être enregistrée car elle reste dans la marge autorisée de {max} mots. Utilisez cette exception seulement si la réduction nuit à la clarté ou à la lisibilité.",
    proposalGraceRangeMessage: "Cette proposition contient {count} mots. La cible standard est de {recommendedMax} mots, mais elle peut être soumise car elle reste dans la marge autorisée de {max} mots. Utilisez cette exception seulement si la réduction nuit à la clarté ou à la lisibilité.",
    breakSceneIntoParagraphsTip: "Conseil : divisez votre scène en paragraphes avant de l’enregistrer. Elle se lira mieux.",
    collaborativeCanonClosedOnlyAuthor: "Mode d’écriture collaborative : seul l’auteur de la storyline ou l’administrateur peut écrire des scènes canon lorsque les propositions sont fermées.",
    groupCanonClosedOnlyAuthor: "Mode d’écriture de groupe : seul l’initiateur peut écrire des scènes canon lorsque les propositions sont fermées. Quand elles s’ouvrent, soumettez plutôt une proposition.",
    canonLockedWhileProposalsOpen: "Lorsque les propositions sont ouvertes, l’écriture canon est verrouillée. Approuvez une proposition ou rejetez-les toutes pour revenir au mode canon.",
    failedToSaveCanonScene: "Impossible d’enregistrer la scène canon. Veuillez réessayer.",
    proposalsAlreadyOpenLong: "Les propositions sont déjà ouvertes. Le tour se ferme seulement lorsque vous approuvez la scène suivante ou rejetez toutes les propositions.",
    proposalsNowOpenWithIntent: "Les propositions sont maintenant ouvertes. Les lecteurs peuvent soumettre, voter, commenter et suivre votre intention pour la scène suivante.",
    proposalsNowOpen: "Les propositions sont maintenant ouvertes. Les lecteurs peuvent soumettre, voter et commenter.",
    writeShortDecisionNote: "Veuillez écrire une brève note de décision avant d’approuver. Une seule phrase suffit.",
    couldNotIdentifyProposal: "Impossible d’identifier la proposition. Veuillez la rouvrir puis réessayer.",
    writerRoleLabel: "Auteur",
    approvedAsNextCanonSceneMessage: "Approuvée comme prochaine scène canon. Les propositions sont fermées. Le mode canon est déverrouillé.",
    rejectedProposalNote: "Une proposition a été rejetée.",
    proposalRemoved: "Proposition supprimée",
    rejectedAllProposalsRound: "Toutes les propositions de ce tour ont été rejetées.",
    roundCleared: "Tour vidé",
    allProposalsRejectedClosedUnlocked: "Toutes les propositions ont été rejetées. Les propositions sont fermées. Le mode canon est déverrouillé.",
    nextScenesStoryline: "Storyline NextScenes",
    readAndFollow: "Lire et suivre",
    mentionsRecentCanon: "Mentionne le canon récent",
    couldNotSaveDraft: "Impossible d’enregistrer le brouillon",
    open: "Ouvert",
    closed: "Fermé",
    roundOpen: "Tour ouvert",
    commentSingle: "commentaire",
    onlyWriterCanReadFullDraft: "Seul l’auteur peut lire le brouillon complet.",
    readFullBookDraftSoFar: "Lire le brouillon complet du livre jusqu’ici.",
    onlyWriterCanViewDecisionLog: "Seul l’auteur peut voir le journal des décisions.",
    reviewCanonDecisionsActions: "Voir les décisions et actions canon.",
    writeYourReply: "Écrivez votre réponse…",
    failedToLoadSelectedStory: "Impossible de charger l’histoire sélectionnée.",
    failedToLoadStorylines: "Impossible de charger les storylines.",
    shelfStatusFailed: "Impossible de charger le statut de la bibliothèque.",
    missingStoryId: "Identifiant de l’histoire manquant.",
    shelfAddFailed: "Échec de l’ajout à la bibliothèque.",
    shelfRemoveFailed: "Échec de la suppression de la bibliothèque.",
    loading: "Chargement…",
    fromLabel: "De",
    selectedStoryLabel: "Histoire sélectionnée",
    noSelectedStory: "Aucune histoire sélectionnée.",
    loadingValidatedScenes: "Chargement des scènes validées…",
    validatedSceneLabel: "Scène validée",
    writerStudioAnchor: "Les histoires se construisent ici avec soin. Lisez, écrivez et contribuez avec intention.",

    writerConfidenceTitle: "Confiance des auteurs",
    writerConfidenceBody:
      "Votre histoire reste la vôtre. Vous décidez ce qui devient Canon. Les contributions acceptées sont enregistrées, et les scènes du Canon pourront plus tard être rassemblées dans un manuscrit.",
    proposalOriginalityTitle: "Soumettez uniquement du contenu original",
    proposalOriginalityBody:
      "En soumettant une proposition, vous confirmez que la scène est votre œuvre originale ou que vous avez le droit de la soumettre. Si elle est approuvée, elle peut devenir partie du Canon de l’histoire et sera enregistrée comme contribution acceptée.",

    scenePosition: "Scène validée {current} sur {total}",
    sceneRecentContext: "Vous lisez la partie la plus récente de cette histoire. Seules les cinq dernières scènes validées sont affichées ici.",
    sceneOpeningContext: "Vous lisez le début de cette histoire.",
    prev: "Précédent",
    next: "Suivant",
    readOpening: "Lire la scène d’ouverture complète",

    continueReading: "Continuer la lecture",

    
  },
};
